// ABOUTME: The one place the job listings module picks its API: pro-core's (./api), or the mock layer's in a dev build
// ABOUTME: that names this module in VITE_MOCK_API. The queries call through here and never know which it is.
import { mockRegistry } from 'mocks/registry';
import * as api from './api';

export const jobListingsApi: typeof api = mockRegistry.apis.jobListings ?? api;

/**
 * Whether the commute to a listing's places can be asked. pro-core has no commute route yet (PJL-056,
 * zenjob/pro-core-service#2034), so only the mock answers it; against pro-core the details leave the link out rather
 * than offer a tap that can only fail. Becomes `true` once that route ships.
 */
export const COMMUTE_SERVED: boolean =
  mockRegistry.apis.jobListings !== undefined;
